module.exports = __webpack_public_path__ + "img/award-1.9dd7b9d0.png";